import { render, staticRenderFns } from "./product-showcase-template.vue?vue&type=template&id=19260e94&scoped=true&"
import script from "./product-showcase-template.vue?vue&type=script&lang=js&"
export * from "./product-showcase-template.vue?vue&type=script&lang=js&"
import style0 from "./product-showcase-template.vue?vue&type=style&index=0&id=19260e94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19260e94",
  null
  
)

export default component.exports